import { styled } from '@mui/material/styles'
import { FilledInput, InputLabel } from '@mui/material'
import theme from 'lib/theme'

export const StyledInput = styled(FilledInput, {
  shouldForwardProp: (props) => props !== 'posAbs',
})<{ posAbs: boolean }>(({ posAbs }) => ({
  button: {
    position: posAbs ? 'absolute' : 'relative',
    top: posAbs ? theme.spacing(0.5) : 0,
  },
  paddingLeft: 0,
  '& .MuiFilledInput-input': {
    padding: theme.spacing(1),
    textFillColor: theme.palette.text.primary,
  },
  '& .MuiFilledInput-root': {
    backgroundColor: theme.palette.action.hover,
    padding: 0,
  },
  '& .Mui-disabled': {
    backgroundColor: 'transparent',
  },
}))

export const StyledLabel = styled(InputLabel)({
  top: '-4px',
  left: '-6px',
  borderRadius: '1px',
  ...theme.typography.body2,
  color: theme.palette.text.secondary,
  transform: 'translate(14px, -11px)',
  '&:active': {
    color: theme.palette.primary.main,
    border: `1px solid ${theme.palette.primary.main}`,
  },
})
